import EDFError from './edf.error';

export default class ValidationError extends EDFError {
    constructor(message: string, cause?: Error) {
        super(message, 'EDF:ValidationError', cause);
    }
}
